var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrcodebox"},[_c('div',{ref:"qrCode",attrs:{"id":"qrcode"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }